import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCroppedEvent, base64ToFile } from 'ngx-image-cropper';
import { DocumentService } from '../../api';
import { SharedVarService, SnackService } from '../../services';

@Component({
  selector: 'school-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.scss']
})
export class ProfileAvatarComponent implements OnInit, OnDestroy {

    message: string = "no";
    confirmButtonText = "Yes";
    cancelButtonText = "Cancel";
    constructor(
        private _snackService: SnackService,
        private _userService: DocumentService,
        private SharedVarservice: SharedVarService,
        private httpClient: HttpClient,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<ProfileAvatarComponent>) {
        if (data) {
            this.message = data.message || this.message;
            if (data.buttonText) {
                this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
                this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
            }
        }
    }

    ngOnInit(): void {

    }


  ngOnDestroy() {
    this.SharedVarservice.setValue(false);
  }

    onConfirmClick(): void {
        this.saveData();
    }

    uploadImage: any = {};
    saveData(): void {

        if (this.croppedImage == undefined) {
            this._snackService.openSnackBar("danger", "Please upload Document...");

        }
        else {
            this._userService.uploadAvatar({})
            .subscribe(
                result => {
                    this._userService.uploadFilesToS3Bucket(result.body.data.file_path, this.profilePicBlob).subscribe((re) => {
                        this._snackService.openSnackBar("success", "Avatar Added Successfully!...");
                        this.croppedImage = '';
                        this.SharedVarservice.setValue(true);
                        this.uploadImage = {};
                        this.dialogRef.close(this.data);
                    });
                }, error => {
                    this._snackService.openSnackBar("danger", "Failed to add a new Avatar...");
                });
        }

    }

    imageChangedEvent: any = '';
    croppedImage: any = '';
    profilePicBlob: Blob;

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;

        this.profilePicBlob = base64ToFile(this.croppedImage);
    }

    imageLoaded() {
        // show cropper
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        this._snackService.openSnackBar("danger", "Invalid File Choosen...");
        // show message
    }

}
